module.exports = __webpack_public_path__ + "img/ex-jargonbot.ba25f38d.png";